export default {
	required: "Este campo es obligatorio",
	requiredField: "El campo {field} es obligatorio",
	email: "Formato de correo electrónico inválido",
	minLength: "El campo {field} debe tener al menos {min} caracteres",
	maxLength: "El campo debe tener máximo {max} caracteres",
	passwordMismatch: "Las contraseñas no coinciden",
	cpfDigits: "El CPF debe tener 11 dígitos",
	cpfInvalid: "CPF inválido — revise los números",
	zipCodeDigits: "El código postal debe tener 8 dígitos",
	invalidPhone: "Teléfono no válido",
};
